import { render, staticRenderFns } from "./kyc.vue?vue&type=template&id=f4d128be&scoped=true"
import script from "./kyc.vue?vue&type=script&lang=js"
export * from "./kyc.vue?vue&type=script&lang=js"
import style0 from "./kyc.vue?vue&type=style&index=0&id=f4d128be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d128be",
  null
  
)

export default component.exports